<template>
  <div class="collection-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />

    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryCollectionLists"
        @search-change="searchChange"
        @refresh-change="queryCollectionLists"
        @selection-change="selectionChange"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="saveData(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="drawer = true">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            v-if="permission.factoringCcollectionManage_writeoff"
            size="small"
            type="primary"
            @click="showWriteOff()"
          >
            核销
          </el-button>
          <el-button
            v-if="permission.factoringCcollectionManage_writeoff"
            size="small"
            type="primary"
            :disabled="outDisabled"
            @click="showOutWriteOff()"
          >
            核销回退
          </el-button>
          <el-button
            v-if="permission.factoringCcollectionManage_writeoff"
            size="small"
            type="primary"
            plain
            @click="chargeAccount()"
          >
            记账
          </el-button>
          <el-button
            v-if="permission.factoringCcollectionManage_writeoff"
            size="small"
            type="primary"
            plain
            @click="recoil()"
          >
            反冲
          </el-button>
        </template>
        <template slot="projectName" slot-scope="{ row }">
          <div class="project-name" @click="queryDetail(row.id)">
            {{ row.projectName }}
          </div>
        </template>
      </avue-crud>
    </div>

    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="filterConfig"
              ref="formScreen"
              v-model="searchForm"
              @submit="filterSearch"
              @reset-change="searchReset"
            >
              <template slot="cust">
                <CommonSelect
                  bindLabel="custName"
                  bindKey="id"
                  bindValue="custName"
                  methods="get"
                  dataMethod="params"
                  dataUrl="bl/custbasicinformationbl/page"
                  @handleChange="setCustId"
                />
              </template>
              <template slot="collectionPlanMoney">
                <div class="form_slot">
                  <el-input-number
                    v-model="searchForm.collectionPlanMoneyMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  &nbsp;~&nbsp;
                  <el-input-number
                    v-model="searchForm.collectionPlanMoneyMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
              <template slot="writeoffTime">
                <div class="block">
                  <el-date-picker
                    v-model="searchForm.writeoffTime"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="选择发证日期范围"
                    end-placeholder="选择发证日期范围"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>

    <el-dialog
      title="核销"
      :visible.sync="dialogVisble"
      :modal-append-to-body="true"
      width="65%"
    >
      <!-- 核销 -->
      <div class="detail-one">
        <div class="detail-top">
          <div class="detail-title">相关信息</div>
        </div>
        <div class="detail-content">
          <CommonDetail
            :configArray="collectionConfig"
            :initValue="collectionData"
          />
        </div>
      </div>

      <div class="detail-one">
        <div class="detail-top">
          <div class="detail-title">请填写本次核销信息</div>
        </div>
        <div class="detail-content">
          <CommonDetail
            :configArray="writeOffConfig"
            :initValue="collectionData"
          />

          <div class="detail-content stone-con">
            <template v-for="(item, index) in paymentList">
              <div class="stone-one" :key="index">
                <div class="form-con">
                  <avue-form
                    ref="paymentInfo"
                    v-model="paymentList[index]"
                    :option="paymentListConfig"
                  >
                    <template #collectionBankId>
                      <CommonSelect
                        ref="bankOpenNameRef"
                        bindLabel="bankOpenName"
                        bindKey="id"
                        bindValue="bankOpenName"
                        methods="get"
                        dataMethod="params"
                        :initParam="initParam"
                        dataUrl="bl/custbankbl/page"
                        @handleChange="
                          (data) => {
                            setBankInfo(data, index);
                          }
                        "
                      />
                    </template>
                  </avue-form>
                </div>
                <!-- <el-divider direction="vertical" v-if="paymentList.length > 1"></el-divider> -->
                <div class="delete-con" v-if="paymentList.length > 1">
                  <i
                    class="el-icon-delete-solid"
                    @click="deletePayment(item, index)"
                  ></i>
                </div>
              </div>
            </template>

            <!-- <div class="add-btn">
                            <el-button size="small" icon="el-icon-plus" @click="addPayment">添加收款</el-button>
                        </div>                              -->
          </div>

          <div class="submit-con">
            <el-button type="primary" size="small " @click="validWriteOffForm()"
              >核销</el-button
            >
            <el-button
              type="primary"
              size="small "
              plain
              @click="dialogVisble = false"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="操作原因"
      :visible.sync="reasonVisble"
      :modal-append-to-body="true"
      width="45%"
    >
      <avue-form
        ref="recoilForm"
        v-model="chargeBackForm"
        :option="chargeBackConifg"
      >
      </avue-form>
      <div class="submit-con">
        <el-button type="primary" size="mini" @click="goRecoil()"
          >反冲</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          @click="reasonVisble = false"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="应收款详情"
      :visible.sync="detailShow"
      :modal-append-to-body="true"
      width="65%"
    >
      <!-- 详细 -->
      <div class="detail-one">
        <div class="detail-top">
          <div class="detail-title">相关信息</div>
        </div>
        <div class="detail-content">
          <CommonDetail
            :configArray="collectionConfig"
            :initValue="collectionData"
          />
        </div>
      </div>

      <div class="detail-one">
        <div class="detail-top">
          <div class="detail-title">
            本次核销信息
            <span class="deal-line" v-if="collectionData.isWriteoff == 1"
              >(核销人员:{{ collectionData.writeoffUserName }}，核销时间:{{
                collectionData.writeoffTime
              }})</span
            >
          </div>
        </div>
        <div class="detail-content">
          <CommonDetail
            :configArray="writeOffConfig"
            :initValue="collectionData"
          />

          <div class="detail-content stone-con">
            <template v-for="(item, index) in collectionData.collectionDetails">
              <CommonDetail
                :key="index"
                class="stone-detail-one"
                :configArray="collectionInConfig"
                :initValue="item"
              />
            </template>
          </div>
        </div>
      </div>
    </el-dialog>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />
  </div>
</template>
<script>
import {
  queryCollectionList,
  queryCollectionDetail,
  chargeToAccounts,
  chargeBack,
  writeOffBack,
  writeOff,
  outWriteOff,
} from "@/api/factoring/factoring";
import {
  collectionListConfig,
  chargeBackConifg,
  writeOffConfig,
  paymentListConfig,
  collectionInfoDialogConfig,
  filterConfig,
  collectionInConfig,
} from "./collectionConfig";
import CommonDetail from "@/components/commonDetail/commonDetail";
import CommonSelect from "@/components/commonSelect/selectInput";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import { mapGetters } from "vuex";
import moment from "moment"
export default {
  name: "CollectionList",
  data() {
    return {
      detailShow: false,
      position: "",
      checkUserList: [],
      checkdepartment: [],
      drawer: false,
      reasonVisble: false,
      dialogVisble: false,
      selectionList: [],
      initParam: { isBusiness: 1 },
      searchForm: {},
      tableData: [],
      paymentList: [
        {
          collectionBankId: "",
          collectionMoney: "",
          collectionDate: "",
          collectionId: "",
        },
      ],
      collectionConfig: collectionInfoDialogConfig(),
      writeOffConfig: writeOffConfig(this.getMoney),
      collectionInConfig: collectionInConfig(this.getMoney),
      tableConfig: collectionListConfig(this.getMoney),
      paymentListConfig: paymentListConfig(),
      chargeBackConifg: chargeBackConifg(),
      filterConfig: filterConfig(this.selectPersonClick, this.selectDeptClick),
      collectionData: {},
      chargeBackForm: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      outDisabled: true,
    };
  },
  components: {
    CommonDetail,
    CommonSelect,
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  watch: {
    selectionList: {
      handler(data) {
        let list = data.filter((item) => {
          return item.isWriteoff == 1;
        });

        this.outDisabled = list.length == 0 || data.length != 1;
      },
      deep: true,
    },
  },
  activated() {
    this.queryCollectionLists();
  },
  methods: {
    async queryDetail(id) {
      let res = await queryCollectionDetail({ id: id });
      if (res.data.code == 200) {
        let array = res.data.data.collectionDetails;
        if (res.data.data.collectionDetails.length > 0) {
          array.map((item) => {
            item.collectionBankStr = `${item.custBankBl.bankAccountName} ${item.custBankBl.bankOpenName} ${item.custBankBl.bankNo}`;
          });
        }
        this.collectionData = res.data.data;
        if (
          this.permission.factoringCcollectionManage_writeoff &&
          this.collectionData.isWriteoff == 0
        ) {
          if (
            this.$refs.selectBank &&
            Object.keys(this.$refs.selectBank[0].bindItem).length > 0
          ) {
            this.$refs.selectBank[0].clearBindItem();
          }
          this.paymentList = [
            {
              collectionBankId: "",
              collectionMoney: "",
              collectionDate: "",
              collectionId: "",
            },
          ];
          if (this.$refs.paymentInfo) this.$refs.paymentInfo[0].clearValidate();
          this.selectionList = [];
          this.selectionList.push(res.data.data);
          this.dialogVisble = true;
        } else {
          this.detailShow = true;
        }
        this.$forceUpdate();
      }
    },
    cloudTages(data) {
      this.searchForm = data;
    },

    saveData(row) {
      this.$refs.cloudtage.save(row);
    },

    setCustId(data) {
      this.searchForm.custId = data.id;
    },
    searchReset() {
      this.searchForm = {};
      this.queryCollectionLists();
    },
    searchChange(str, done) {
      this.queryCollectionLists();
      done();
    },
    filterSearch(str, done) {
      // 处理过滤条件
      this.searchForm.isWriteoff = this.searchForm.writeoff;
      this.searchForm.isBooking = this.searchForm.booking;
      if (this.searchForm.writeoffTime != []) {
        this.searchForm.writeoffTimeMin = this.searchForm.writeoffTime[0];
        this.searchForm.writeoffTimeMax = this.searchForm.writeoffTime[1];
      }

      this.queryCollectionLists();
      done();
    },
    setBankInfo(data, index) {
      this.paymentList[index].collectionBankId = data.id;
    },

    // addPayment() {
    //     let obj = {
    //         payBankId: '',
    //         payMoney: '',
    //         payDate: '',
    //         paymentId: ''
    //     }
    //     this.paymentList.push(obj)
    // },

    deletePayment(data, index) {
      let self = this;
      this.$confirm("确定删除该条收款信息?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let newArray = [];
        newArray = newArray.concat(
          JSON.parse(JSON.stringify(self.paymentList))
        );
        newArray.splice(index, 1);
        self.paymentList = newArray;
      });
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    async queryCollectionLists() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        collectionPlanDateBegin: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
          : undefined,
        collectionPlanDateEnd: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
          : undefined,
        timePic:undefined  
      };
      let res = await queryCollectionList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    async showOutWriteOff() {
      let self = this;

      this.$confirm("确定回退该条收款信息?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = this.selectionList[0];
          let res = await outWriteOff({ id: data.id });
          if (res.data.code == 200) {
            self.queryCollectionLists();
          }
        })
        .catch(() => {});
    },
    async showWriteOff() {
      let that = this;
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行核销");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        if (data.isWriteoff == 0) {
          let res = await queryCollectionDetail({ id: data.id });
          if (res.data.code == 200) {
            this.dialogVisble = true;
            this.paymentList.map((item, index) => {
              Object.assign(item, {
                collectionBankId: "",
                collectionMoney: "",
                collectionDate: "",
                collectionId: "",
              });
              if (this.$refs.bankOpenNameRef)
                this.$refs.bankOpenNameRef[index].reset();

              if (this.$refs.paymentInfo)
                this.$refs.paymentInfo[index].clearValidate();
            });
            this.collectionData = res.data.data;
          }
        } else {
          this.$message({
            type: "warning",
            message: `该条数据已核销`,
          });
        }
      } else {
        this.$message.error("请选择一条数据进行核销");
      }
    },

    async validWriteOffForm() {
      // 校验付款信息
      let valid = true;
      let self = this;

      this.paymentList.map((item, index) => {
        if (
          item.collectionBankId == "" ||
          item.collectionMoney == "" ||
          item.collectionDate == ""
        ) {
          valid = false;
          self.$message({
            type: "warning",
            message: `请先补全第${index + 1}条付款信息`,
          });
        } else {
          item.collectionId = self.selectionList[0].id;
        }
      });

      if (valid) {
        // 核销

        let params = {
          id: this.selectionList[0].id,
          custId: this.collectionData.custId,
          collectionDetails: this.paymentList,
          investId: this.selectionList[0].investPaymentId,
        };
        let res = await writeOff(params);
        if (res.data.code == 200) {
          this.paymentList.map((item, index) => {
            Object.assign(item, {
              collectionBankId: "",
              collectionMoney: "",
              collectionDate: "",
              collectionId: "",
            });
            if (this.$refs.bankOpenNameRef)
              this.$refs.bankOpenNameRef[index].reset();

            if (this.$refs.paymentInfo)
              this.$refs.paymentInfo[index].clearValidate();
          });

          this.dialogVisble = false;

          this.queryCollectionLists();
          this.$message({
            type: "success",
            message: "核销成功",
          });
        }
      }
    },

    // 记账
    chargeAccount() {
      let self = this;
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行核销");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        if (data.isBooking == 0) {
          this.$confirm("是否确定记账次数据?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            let res = await chargeToAccounts({ id: data.id });
            if (res.data.code == 200) {
              self.queryCollectionLists();
              self.$message({
                type: "success",
                message: "记账成功",
              });
            }
          });
        } else {
          this.$message({
            type: "warning",
            message: `该条数据已记账`,
          });
        }
      } else {
        this.$message.error("请选择一条数据进行核销");
      }
    },

    async recoil() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行反冲");
      } else if (this.selectionList.length == 1) {
        this.reasonVisble = true;
      } else {
        this.$message.error("请选择一条数据进行核销");
      }
    },

    goRecoil() {
      let self = this;
      this.$refs.recoilForm.validate(async (valid, done) => {
        done();
        if (valid) {
          let data = self.selectionList[0];
          let res = await chargeBack({
            id: data.id,
            remarks: self.chargeBackForm.remarks,
          });
          self.reasonVisble = false;
          if (res.data.code == 200) {
            self.queryCollectionLists();
            self.$message({
              type: "success",
              message: "反冲成功",
            });
          }
        }
      });
    },

    setPeople(val) {
      this.checkUserList = val;
      // this.getVisitPeople();
      let people = val.map((item) => {
        return item.realName;
      });
      let ids = val.map((item) => {
        return item.id;
      });
      if (this.position == "managerUserName") {
        this.searchForm.managerUser = ids.join(",");
        this.searchForm.managerUserName = people.join(",");
      } else {
        this.searchForm.writeoffUser = ids.join(",");
        this.searchForm.writeoffUserName = people.join(",");
      }
    },

    setDepartment(data = []) {
      this.checkdepartment = data;
      let titleList = data.map((item) => {
        return item.title || item.fullName;
      });
      let ids = data.map((item) => {
        return item.key;
      });

      this.searchForm.managerDeptName = titleList.join(",");
      this.searchForm.managerDeptId = ids.join(",");
    },

    selectDeptClick() {
      this.$refs.selectdepartment.showModel();
    },

    selectPersonClick(name) {
      this.position = name;
      this.checkUserList = [];
      this.$refs.selectperson.showmode();
    },
  },
};
</script>
<style lang="scss" scoped>
.collection-list-container {
  /deep/.el-table .cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }    
  /deep/ .avue-group--card {
    padding: 0 0 !important;
  }

  /deep/ .el-dialog__header {
    border-radius: 5px 5px 0px 0px;
    background-color: rgb(245, 245, 245);
    color: #333;
  }
  // /deep/ .el-dialog__body{
  //     padding: 10px 20px 20px !important;
  // }
  // /deep/ .el-col{
  //     padding-left: 0 !important;
  // }
  // /deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  //     margin-bottom: 0 !important;
  // }

  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .manage-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    // overflow: hidden;
    white-space: normal;
    // text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .deal-line {
    font-weight: 400 !important;
    font-size: 12px !important;
    color: #666666 !important;
  }

  .detail-one {
    padding: 0px 30px !important;
    .detail-top {
      padding: 20px 5px;
      .detail-title {
        color: #666;
        font-weight: 700;
        font-size: 14px;
        line-height: 28px;
        position: relative;
        .title-tips {
          font-weight: 400;
          color: #666666;
          font-size: 13px;
        }
      }
      .detail-title::before {
        content: "";
        width: 5px;
        background-color: #409eff;
        height: 18px;
        position: absolute;
        left: -12px;
        top: 5px;
      }
    }

    .stone-con {
      width: 88%;
      margin: 0 auto;
      .stone-detail-one {
        background-color: #f7f9fe;
        padding: 10px 10px 10px 10px;
        border: 1px solid #e4e4e4;
        border-radius: 4px;
        margin-bottom: 10px;
        .el-collapse-item__wrap {
          background-color: #f7f9fe !important;
          border: none !important;
        }
        .el-collapse {
          border: none !important;
        }
        .el-form-item {
          margin-top: 14px !important;
          margin-bottom: 14px !important;
        }
      }
      .stone-one {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #f7f9fe;
        padding: 30px 10px 10px 10px;
        border: 1px solid #e4e4e4;
        border-radius: 4px;
        margin-bottom: 10px;
        .form-con {
          // border-right:  1px dashed #e4e4e4;
        }
        .delete-con {
          width: 300px;
          height: 100%;
          text-align: center;
          i {
            font-size: 30px;
            color: #409eff;
          }
        }
        .el-collapse-item__wrap {
          background-color: #f7f9fe !important;
          border: none !important;
        }
        .el-collapse {
          border: none !important;
        }
        .el-form-item {
          margin-top: 14px !important;
          margin-bottom: 14px !important;
        }
      }
      /deep/.el-collapse-item__wrap {
        background-color: #f7f9fe !important;
        border: none !important;
      }
      /deep/.el-collapse {
        border: none !important;
      }
    }

    .add-btn {
      text-align: right;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  .submit-con {
    text-align: center;
    margin-bottom: 40px;
    button {
      width: 150px;
    }
  }
}
</style>